export default "__VITE_ASSET__DLkd_SXx__"